import {ActionIcon, Box, Button, Container, Modal, TextInput, Title} from '@mantine/core';
import {useForm} from '@mantine/form';
import KeyBoard from "./KeyBoard";
import IconDeleteButton from "../../Icon/IconDeleteButton";
import axiosInstance from "../../Helper/axiosInstance";
import {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

const UserForm = ({inputNeeded}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const {id} = useParams();
    const navigate = useNavigate();
    const serviceId = Number(id);
    const form = useForm(
        {
            initialValues: {nationalCode: "", phoneNumber: ""},
            validate: {
                nationalCode: (value) => value.length !== 10 ? 'کد ملی باید 10 رقم باشد' : null,
                phoneNumber: (value) => inputNeeded ? (value.slice(0, 2) !== '98' ? 'شماره تلفن خود را با 98 در ابتدا شروع کنید' : value.length !== 12 ? 'شماره تلفن باید 12 رقم باشد' : null) : null,
            }
        }
    );

    const clearAll = <ActionIcon onClick={() => {
        form.setFieldValue('nationalCode', '')
    }}><IconDeleteButton/></ActionIcon>
    const clearPhoneNumber = <ActionIcon onClick={() => {
        form.setFieldValue('phoneNumber', '')
    }}><IconDeleteButton/></ActionIcon>

    const onInputAdd = (value) => {
        form.setFieldValue('nationalCode', (form.values?.nationalCode ?? '') + value)


    };
    const onInputRemove = () => {
        form.setFieldValue('nationalCode', (form.values?.nationalCode ?? '').slice(0, -1))
    };

    const submitHandler = form.onSubmit((values, event) => {
        const nationalId = values.nationalCode;
        const phoneNumberFromServer = localStorage.getItem('phoneNumber')
        const mobile = phoneNumberFromServer.length > 0 ? phoneNumberFromServer : values.phoneNumber ;
        localStorage.setItem('phoneNumber', mobile);
        const id = 0;
        axiosInstance.post(`https://api_bi.shadnoyan.com/rubika/RegisterUserInfo`, {
            id,
            nationalId,
            mobile,
            serviceId,
        }).then(({data}) => {
            if (data.data.url) window.location = data.data.url;

            if (data.data.fileUpload) {
                navigate(`/${serviceId}/file`);
            }
            if (data.status === 208) {
                setIsOpen(true);
                setMessage(data.message);
            }
        }).catch((error) => {
            setIsOpen(true);
            setMessage(error?.data.message ?? 'خطا در برقراری ارتباط');
        });

    })


    return (
        <Box className="min-w-full rounded-t-2xl bg-white py-6">
            <Container>
                <Title size="h2"
                       className="mb-2">{inputNeeded ? 'اطلاعات خود را وارد کنید' : 'کد ملی خود را وارد کنید'}</Title>
                <form className="bg-white flex flex-col gap-5 flex-1" onSubmit={submitHandler}>
                    <TextInput
                        className="p-4 placeholder:text-right text-right focus:ring-greenTwo text-greenTwo"
                        rightSection={clearAll}
                        placeholder="...کد ملی"
                        radius="md"
                        type="tel"
                        dir="ltr"
                        size="xl"
                        {...form.getInputProps('nationalCode')}
                    />
                    {inputNeeded ? (
                        <div className="flex flex-col justify-center items-center ">
                            <TextInput
                                className="p-4 placeholder:text-right text-right focus:ring-greenTwo text-greenTwo min-w-full"
                                rightSection={clearPhoneNumber}
                                placeholder="...شماره تلفن"
                                radius="md"
                                description="شماره تلفن خود را بدون 0 و با 98 در ابتدا وارد کنید"
                                type="tel"
                                dir="ltr"
                                size="xl"
                                {...form.getInputProps('phoneNumber')}
                            />
                            <Button size={"xl"} radius="md"
                                    className="w-full bg-greenTwo max-w-[200px] mt-4 hover:bg-greenThree"
                                    type="submit"> ورود</Button>
                        </div>
                    ) : (
                        <KeyBoard removeChar={onInputRemove} addChar={onInputAdd}/>
                    )}
                </form>
            </Container>
            <Modal opened={isOpen} onClose={() => setIsOpen(false)} radius={"xl"} size={"sm"} centered
                   withCloseButton={false}
                   className="text-center text-2xl font-bold  text-red-600"> {message ? message : 'موفق نشدیم '}  </Modal>
        </Box>

    );
}
export default UserForm;